import styled from "styled-components";
import { Link } from "gatsby";
import arrowSvg from "@assets/images/icons/menu arrow.svg";
import logo from "@assets/images/Tonic3_RGB_1.webp";

export const Container = styled.header`
  padding: 16px 40px;
  display: flex;
  align-items: center;
  background-color: #141301;
  column-gap: 60px;
  position: fixed;
  width: 100%;
  height: 90px;
  z-index: 99999;

  @media (max-width: 600px) {
    padding: 16px 24px;
    justify-content: space-between;
    height: 87px;
  }
`;

export const LogoLink = styled(Link)`
  display: flex;
`;

export const Logo = styled.img`
  margin: 0;
  content: url(${logo});
  max-width: 72px;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  column-gap: 32px;
`;

export const NavLinkContainer = styled.button`
  display: flex;
  align-items: center;
  column-gap: 8px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;

  span {
    color: ${({ active }) => active && "#BABABA"};
  }

  div {
    background-color: ${({ active }) => active && "#BABABA"};
    transform: ${({ active }) => active && "rotate(180deg)"};
  }

  &:hover {
    span {
      color: #bababa;
    }
    div {
      background-color: #bababa;
    }
  }
`;

export const NavLink = styled.span`
  color: #fff6ed;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
`;

export const NavIcon = styled.div`
  width: 24px;
  height: 24px;
  background-color: #fff6ed;
  -webkit-mask: url(${arrowSvg}) no-repeat center;
  mask: url(${arrowSvg}) no-repeat center;
  mask-size: contain;
  -webkit-mask-size: contain;
`;

export const NavDirectLink = styled(Link)`
  color: #fff6ed;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    color: #bababa;
  }
`;

export const NavExternalLink = styled.a`
  color: #fff6ed;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    color: #bababa;
  }
`;
